import { Pipe } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({ name: 'whgtranslate', pure: false })
export class SkolI18nPipe extends TranslatePipe { }
